export default __webpack_public_path__ + "static/media/img4.dbe71aa9.png";